<template>
    <div class="rounded-4 bg-white border h-100 overflow-hidden position-relative">
        <div class="row g-0 h-100">
            <div class="col-sm position-relative">
                <div class="ratio ratio-21x9 h-100">
                    <img :src="vehicle.thumbnail ?? '/images/front/placeholder.png'" :alt="vehicle.title" class="img-fluid object-fit-cover w-100 h-100">
                </div>
                <div class="position-absolute bottom-0 start-0 end-0 bg-trout-caviar px-3 py-2"
                    v-if="!$page.props.user?.is_agent && vehicle.discount > 0">
                    <div class="hstack gap-2 flex-wrap justify-content-between">
                        <div class="text-white fs-12 ff-dsb"><i class="fas fa-tags"></i> Special Offer!</div>
                        <div class="text-white fs-12 ff-dsb">{{ vehicle.discount_formatted }} OFF</div>
                    </div>
                </div>
            </div>
            <div class="col-sm">
                <div class="p-3 vstack gap-3 h-100">
                    <h5 class="fs-18 ff-dsb mb-0">{{ vehicle.title }}</h5>
                    <div class="hstack gap-3">
                        <div class="p-2 bg-errigal-white rounded-2 w-100" v-if="vehicle.mileage_formatted">
                            <i class="fal fa-tachometer-fast text-primary fs-18"></i>
                            <div class="fs-14 text-nowrap">{{ vehicle.mileage_formatted }} KM</div>
                        </div>
                        <div class="p-2 bg-errigal-white rounded-2 w-100" v-if="vehicle.fuel_type">
                            <i class="fal fa-gas-pump text-primary fs-18"></i>
                            <div class="fs-14 text-nowrap text-capitalize">{{ vehicle.fuel_type }}</div>
                        </div>
                        <div class="p-2 bg-errigal-white rounded-2 w-100" v-if="vehicle.seating_number">
                            <i class="fal fa-user text-primary fs-18"></i>
                            <div class="fs-14 text-nowrap">{{ vehicle.seating_number }} Seats</div>
                        </div>
                    </div>
                    <div class="vstack gap-1">
                        <div class="d-flex flex-wrap gap-2 align-items-center"
                            v-if="vehicle.vehicle_type === 1 || vehicle.vehicle_type === 2">
                            <h4 class="text-primary ff-dsb mb-0">{{ vehicle.discounted_price_formatted }}</h4>
                            <div class="fs-13 ff-dsb opacity-50 text-decoration-line-through" v-if="!$page.props.user?.is_agent && vehicle.discount">{{
                                vehicle.price_formatted }}</div>
                        </div>
                        <div class="d-flex flex-wrap gap-2 align-items-center" v-else>
                            <h4 class="text-primary ff-dsb mb-0">{{ vehicle.daily_rate_formatted }} /daily</h4>
                        </div>
                        <div class="fs-15 ff-dsb" v-if="vehicle.vehicle_type === 1 || vehicle.vehicle_type === 2">{{
                            vehicle.monthly_price_formatted }} /mth</div>
                        <!-- <div class="fs-15 ff-dsb" v-else>{{ vehicle.daily_rate_formatted }} /daily</div> -->
                    </div>
                    <div class="hstack gap-3">
                        <Link :href="route('front.vehicles.show', vehicle.slug)"
                            class="btn btn-outline-primary fs-15 ff-dsm rounded-3 d-block flex-fill stretched-link">View
                        Details <ButtonArrowIcon /></Link>
                        <div v-if="$page.props.user" class="rounded-circle fav-icon d-flex text-fennel-fiasco fs-14 z-1 btn-fav" @click="addToFavourite(vehicle.id)">
                            <i class="fa-heart m-auto" :class="($page.props.user.fav_vehicles.find(favVehicle => favVehicle.vehicle_id === vehicle.id) )? 'fas' : 'fal'"></i>
                        </div>
                        <Link :href="route('user.login')" v-else class="rounded-circle fav-icon d-flex text-fennel-fiasco fs-14 z-1 btn-fav">
                            <i class="fa-heart m-auto fal"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import axios from 'axios';
import ButtonArrowIcon from './icons/ButtonArrowIcon.vue';

defineProps({ vehicle: Object })

const page = usePage();
function addToFavourite(vehicleId) {
    axios.post(route('user.favourites.add'), {
        vehicle_id: vehicleId
    })
        .then((response) => {
            page.props.user.fav_vehicles = response.data.user_fav_vehicles;
        })
        .catch((error) => {
            console.error('There was an error!', error);
        });
};
</script>
